/* eslint-disable function-paren-newline */
// Libs
import moment from 'moment';

function MakerModel(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

MakerModel.prototype = Object.assign(MakerModel.prototype, {
    createTableData(tableData) {
        if (
            tableData &&
            tableData.getMakerCheckerResponseList &&
            tableData.getMakerCheckerResponseList.length > 0
        ) {
            return tableData.getMakerCheckerResponseList.map(row =>
                this.createRow(row)
            );
        }
        return [];
    },
    createPaginationData(data) {
        if (data) {
            const { totalElements } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: 0,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalElements,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            createdAt,
            idempotencyId,
            eventType,
            makerId,
            makerRequestId,
            status,
            request,
            remarks,
            childCheckerResponseList,
            checkerRemarks,
            userActionStatus,
            updatedAt,
        } = row;
        let userStatus = status;
        if (status === 'PENDING_APPROVAL') {
            userStatus = 'PENDING_FOR_APPROVAL';
        }
        return {
            createdAt: this.formatData(createdAt),
            idempotencyId,
            eventType,
            makerId,
            makerRequestId,
            status: userStatus || '-',
            request,
            remarks,
            childCheckerResponseList,
            checkerRemarks,
            userActionStatus,
            updatedAt: this.formatData(updatedAt),
        };
    },
    formatData(date) {
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
});

export default MakerModel;
